import { styled } from "../../../../styled-components";

export const ProgressIndicatorWrapper = styled.div``;

export const Title = styled.div`
    ${p => p.theme.fontStyles.AccentHeader4};

    color: ${p => p.theme.fgColorDark};
    margin-bottom: 8px;
`;

export const Trough = styled.div`
    position: relative;
    height: 8px;
    background: ${p => p.theme.separatorColor};
    border-radius: 4px;
    overflow: hidden;

    margin: 0 16px;
`;

export const Fill = styled.div<{ progress: string }>`
    position: absolute;

    left: 0;
    top: 0;
    bottom: 0;
    width: ${p => p.progress}%;

    background-color: ${p => p.theme.primaryAccentColor};
`;
